/**
 * @author Ariel
 * @description 经销商管理
 * @Date 2020/1/10
 */
import React from "react";
import {connect} from "dva";
import {templateConfig,reduxTemplateConfig} from "./config";
import {component_tool,framework_tool} from '../../../tool';
let {WizContainer, WizReduxTemplate} = framework_tool;
let {WizBrowserExport} = component_tool

class DealerManager extends WizContainer {
  componentName = 'dealerManager';

  constructor(props) {
    super(props);
    this.state={
    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '经销商名称',
        field: 'name',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '经销商简称',
        field: 'shortName',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '销售代码',
        field: 'preSalesNumber',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '售后代码',
        field: 'afterSalesNumber',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '站点类型',
        field: 'type',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '组织',
        field: 'orgName',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '省份',
        field: 'province',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开店状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '开店时间',
        field: 'openTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '在职人数',
        field: 'onJobNumber',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      }

    ]

    let dict = [
        {code: 1, codeName: '经销商'},
        {code: 2, codeName: '服务商'},
    ]


    if (o['success']) {
      let data = o['data']
      data && data.forEach(e => {
        let {brandName,areaName} = e
        if(brandName && brandName.length) {
          e.orgName = brandName
          if (areaName && areaName.length) {
            e.orgName = brandName + '>' + areaName
          }
        } else if (areaName && areaName.length) {
          e.orgName = areaName
        }
        e.state === 2 ? e.state = '停业' : e.state === 1 ?  e.state = '开业' :  e.state = '待开业'
        dict.forEach(element=>{
          if(e.type==element.code){
            e.type = element.codeName
          }
        })

      })
      WizBrowserExport({
        title: '经销商信息',
        sheetName: '经销商信息',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '经销商信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: templateConfig({jumpPage:this.jumpPage}),
      apiDataFormat: {
        delete: this._handleCMD,
        export: this._handleFile
      }
    })
    return <WizReduxTemplate {..._reduxTemplateConfig}/>
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(DealerManager);
